<template>
  <div class="detail-wrap">
    <div class="detail-title">
      {{titleName}}
      <div class="iconfont iconfanhui icon-back" v-if="listName" @click="backList"></div>
      <div class="iconfont iconguanbi close-detail" @click="hide"></div>
    </div>
    <div class="detail-content">
      <slot></slot>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
export default {
  components: {},
  props: ['titleName', 'listName'],
  name: 'detail',
  data() {
    return {};
  },
  methods: {
    ...mapActions([]),
    hide() {
      this.$emit('hideDetail', true);
    },
    backList() {
      this.$emit('backList', this.listName);
    }
  },
  watch: {},
  computed: {
    ...mapGetters([])
  },
  created() {},
  mounted() {}
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss" rel="stylesheet/scss">
@import "../assets/scss/common.scss";
.detail-wrap {
  z-index: 1;
  width: 100%;
  height: 100%;
  background-color: #002543;
  .detail-title {
    position: relative;
    width: 100%;
    height: 68px;
    line-height: 68px;
    color: $white;
    font-size: 28px;
    text-align: center;
    font-weight: bold;
    background-image: linear-gradient(to right, #0d4f78, #229ac6, #0d4f78);
    &::before {
      position: absolute;
      left: 0;
      top: 0;
      width: 100%;
      height: 3px;
      background-image: linear-gradient(
        to right,
        transparent,
        #3ddbeb,
        transparent
      );
      content: "";
    }
    .close-detail {
      position: absolute;
      right: 0;
      top: 0;
      font-size: 22px;
      padding-right: 32px;
      padding-left: 32px;
      font-weight: normal;
      color: #32b6d7;
      cursor: pointer;
    }
    .icon-back {
      position: absolute;
      left: 0;
      top: 0;
      font-size: 40px;
      padding-right: 32px;
      padding-left: 32px;
      font-weight: normal;
      color: #32b6d7;
      cursor: pointer;
    }
  }
  .detail-content {
    width: 100%;
    height: calc(100% - 68px);
    padding: 30px 12px 30px 30px;
  }
}
</style>